import { IClient } from "./config";

export const generateUrl = (
  client: IClient,
  endpointKey: keyof IClient["endpoint"],
  params: Record<string, string> | null,
  queryParams: Record<string, string> | null
): string => {
  const endpoint = client.endpoint[endpointKey];
  let { pathname } = endpoint.uri;
  if (params) {
    Object.keys(params).forEach((key) => {
      pathname = pathname.replace(`:${key}`, params[key]);
    });
  }

  let queryString = "";
  if (queryParams) {
    queryString = Object.keys(queryParams)
      .flatMap((key) => {
        const value = (queryParams as any)[key];
        if (Array.isArray(value)) {
          return value.map((v: string) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
        }
        if (value === undefined || value === null || value === "") return [];
        return [`${encodeURIComponent(key)}=${encodeURIComponent(value)}`];
      })
      .join("&");
  }
  return `${pathname}${queryString ? `?${queryString}` : ""}`;
};
